export default __webpack_public_path__ + "static/media/uoit.c1952284.png";